import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=477a0fda&scoped=true"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=477a0fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a0fda",
  null
  
)

export default component.exports